import { Component, ChangeDetectionStrategy, ChangeDetectorRef, HostBinding } from '@angular/core';
import { FormBaseComponent } from '../../models/form-base-component';
import { FormInjectField } from './form-inject.model';
import { FormFieldService } from '../../services/form-field.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'gio-form-inject',
  templateUrl: './form-inject.component.html',
  styleUrls: ['./form-inject.component.scss'],
  host: {
    '[class]': 'classNames'
  },
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormInjectComponent<N = any> extends FormBaseComponent<FormInjectField<N>> {

  @HostBinding('style')
  get myStyle() { return this.getHostStyles(); }

  constructor(
    cd: ChangeDetectorRef,
    public _service: FormFieldService,
    sanitizer: DomSanitizer
    ) {
    super(cd, _service, sanitizer);
  }
  onComponentInit() { }

  onComponentDestroy() { }
}
